'use client'

import { useEffect } from 'react'

import type { WebMCPTool } from '@/lib/mcp/web-tools'

interface ModelContext {
  provideContext: (context: { tools: WebMCPTool[] }) => void | Promise<void>
}

declare global {
  interface Navigator {
    modelContext?: ModelContext
  }
}

// The tool table carries the whole project catalog, so it loads only in a
// browser that actually exposes WebMCP. WebMCP is experimental; a rejected shape
// or a failed chunk load is swallowed.
async function registerTools(modelContext: ModelContext) {
  try {
    const { webMCPTools } = await import('@/lib/mcp/web-tools')
    await modelContext.provideContext({ tools: webMCPTools })
  } catch {}
}

export function WebMCP() {
  useEffect(() => {
    const modelContext = navigator.modelContext
    if (!modelContext?.provideContext) return
    void registerTools(modelContext)
  }, [])

  return null
}
